import React from 'react';
import ProjectTemplateAutoAssignmentRuleSelect from './ProjectTemplateAutoAssignmentRuleSelect';

const ProjectTemplateAutoAssignmentRuleEmploymentTypeSelect = props => {
  const {
    className,
    'data-test-id': dataTestId,
    employmentTypeId,
    onChange,
  } = props;
  const options = [
    { label: 'W2', value: 1, id: 1 },
    { label: 'Loan Out', value: 2, id: 2 },
  ];
  return (
    <ProjectTemplateAutoAssignmentRuleSelect
      label="Employment Type"
      options={options}
      value={employmentTypeId}
      onChange={employmentTypeId =>
        onChange(options.find(({ value }) => value === employmentTypeId))
      }
      data-test-id={dataTestId}
      className={className}
    />
  );
};

export default ProjectTemplateAutoAssignmentRuleEmploymentTypeSelect;
